import { useEffect, useState } from "react";
import CampaignsTab from "../components/campaigns/CampaignsTab";
import useShellContext from "../layout/useShellContext";

export default function CampaignsPage() {
  const { registerPageControls, resetPageControls, showToast } = useShellContext();
  const [refreshSignal, setRefreshSignal] = useState(0);

  useEffect(() => {
    registerPageControls({
      onRefresh: async () => {
        setRefreshSignal((current) => current + 1);
      },
      refreshEvery: "Manual",
      lastUpdated: "--",
      isRefreshing: false,
    });

    return () => {
      resetPageControls();
    };
  }, [registerPageControls, resetPageControls]);

  return (
    <CampaignsTab
      active
      refreshSignal={refreshSignal}
      showToast={showToast}
    />
  );
}
